module.exports = __webpack_public_path__ + "static/ui-icons_555555_256x240.png";